import React from "react";
import styles from "./styles.module.scss";
import { formattedPrice } from "../../../../../../../../views/pages/manage/unAssigned/collectPayment/utils";

export const calculationLabelFieldMappings = [
    { label: "A. Registration Fees", field: "registrationFees" },
    { label: "B. Admission Fees", field: "admissionFees" },

    {
        label: "C. Total Installment Fee Payable (Net Payable - Reg - Adm)",
        field: "totalInstallmentFeePayable"
    },

    {
        label: "D. Total Duration of the Course",
        field: "totalDurationOfCourse",
        isAmount: false
    },

    {
        label: "E. Usage Duration Opted by the Student",
        field: "usageDuration",
        isAmount: false
    },

    { label: "F. 1st Installment Payable", field: "firstInstallmentPayableAmount" },
    { label: "G. 1st Installment Paid Amount", field: "firstInstallmentPaidAmount" },

    {
        label: "H. Total Fee Paid by the Student (Excl. Security Fees)",
        field: "totalFeePaidExcludingSecurity"
    },

    {
        label: "I. Total Installment Paid on or after Refund Application Date",
        field: "totalInstallmentsPaidOnOrAfterRefundDate"
    },

    {
        label: "J. Per Day Fee for the Course (Net payable / Total duration)",
        field: "perDayFee"
    },
];




const CalculationRow = ({ label, value, isAmount }) => {
    const formattedValue =
        isAmount
        ? formattedPrice(value)
        : value > 0 ? value : "—"

    return (
        <div className={styles.row}>
            <span className={styles.label}>{label}</span>
            <span className={styles.value}>{formattedValue}</span>
        </div>
    );
};




const CalculationsCard = ({ calculatedData = {} }) => {

    const leftColumn = calculationLabelFieldMappings.slice(0, 5);
    const rightColumn = calculationLabelFieldMappings.slice(5);

    return (
        <div className={styles.container}>
            <h3 className={styles.title}>Calculation • {(calculatedData?.weekForRefund <= 4) ? 'PRS' : 'PRO'}</h3>

            <div className={styles.grid}>
                <div className={styles.column}>
                    {leftColumn.map((el) => {
                        const { label, field, isAmount = true } = el;
                        return (
                            <CalculationRow
                                key={field}
                                label={label}
                                value={calculatedData?.[field]}
                                isAmount={isAmount}
                                
                            />
                        );
                    })}
                </div>

                <div className={styles.column}>
                    {rightColumn.map((el) => {
                        const { label, field, isAmount = true } = el;
                        return (
                            <CalculationRow
                                key={field}
                                label={label}
                                value={calculatedData?.[field]}
                                isAmount={isAmount}
                            />
                        );
                    })}
                </div>
            </div>
        </div>
    );
};

export default CalculationsCard;
